import { JID, Status } from '@bidi/chat-client';
import { ActionReducerMap } from '@ngrx/store';
import { RatingsActionTypes } from './actions';
import { group } from '@angular/animations';

export function ratings (state = [], { type, payload }: any) {
  switch (type) {
    case RatingsActionTypes.GET_RATINGS_SUCCESS:
      let flag = true;
      if (state.length > 0) {
        state.map(function (res) {
          if (res.id === payload.id) {
            flag = false;
          }
        });
      }
      if (flag) {
        return state.concat([payload]);
      } else {
        return state;
      }
      // return state.concat([payload]);
    case RatingsActionTypes.SET_RATINGS_SUCCESS:
      return state.map(res => res.id === payload.id
        ? {
          ...res,
          ratings: res.ratings.concat(payload.data)
        }
        : res
      );
    default:
      return state;
  }
}

export interface State {
  ratings: any;
}

export const reducers: ActionReducerMap<State> = {
  ratings
};
